import React from 'react';
import { useIntl } from 'react-intl';

import { ProjectList } from '@components/organisms/ProjectList';
import { ProjectFilter } from '@components/organisms/ProjectFilter';

import * as S from './styles';

interface PageProps {
  filters: {
    attributes: {
      [key: string]: string[];
    };
  };
  attributes: Array<{
    id: string;
    name: string;
    slug: string;
    values: Array<{
      id: string;
      name: string;
      slug: string;
      selected?: boolean;
      url?: string;
      color?: string;
    }>;
  }>;
  projects: Array<{
    id: string;
    category: string;
    name: string;
    title: string;
    image: any;
  }>;
  hasNextPage: boolean;
  clearFilters: () => void;
  onAttributeFiltersChange: (attributeSlug: string, value: string) => void;
  onLoadMore?: () => void;
}

const Page: React.FC<PageProps> = ({
  attributes,
  filters,
  projects,
  hasNextPage,
  clearFilters,
  onAttributeFiltersChange,
  onLoadMore,
}) => {
  const intl = useIntl();
  return (
    <S.Wrapper className="realisation">
      <S.Header>
        <S.Title>
          {intl.formatMessage({
            defaultMessage: 'Inspirations',
            id: 'qf/vV3',
          })}
        </S.Title>
      </S.Header>
      <S.Content>
        <ProjectFilter
          attributes={attributes}
          filters={filters}
          clearFilters={clearFilters}
          onAttributeFiltersChange={onAttributeFiltersChange}
        />
        <ProjectList
          projects={projects}
          onLoadMore={onLoadMore}
          hasNextPage={hasNextPage}
        />
      </S.Content>
    </S.Wrapper>
  );
};

Page.displayName = 'RealisationPage';

export default Page;
